import { string2Array } from '@/utils';
import { LifecycleManageData } from '../../lifecycle-manage';
import { LifecycleItem } from '../../types';

/**
 * 声明周期管理数据转换为 yaml 数据
 */
export function lifecycleToYaml(item: LifecycleManageData): LifecycleItem {
  if (!item) return undefined;
  const tab = item.tab;
  switch (tab) {
    case 'TCP_PORT': {
      return {
        tcpSocket: {
          port: item.tcpPort,
        },
      };
    }
    case 'COMMAND': {
      return {
        exec: {
          command: string2Array(item.command),
        },
      };
    }
    case 'HTTP':
      return {
        httpGet: {
          scheme: item.protocol,
          path: item.path,
          port: item.httpPort,
        },
      };
    default:
      return undefined;
  }
}

export function yamlToLifecycle(item: LifecycleItem): LifecycleManageData {
  if (!item) return undefined;

  if ('tcpSocket' in item && item.tcpSocket) {
    return {
      tab: 'TCP_PORT',
      tcpPort: item.tcpSocket.port,
    };
  }
  if ('exec' in item && item.exec) {
    return {
      tab: 'COMMAND',
      // 假设 string2Array 的反向操作为 join，如果有其它逻辑请根据实际情况修改
      command: Array.isArray(item.exec.command) ? item.exec.command.join(',') : item.exec.command,
    };
  }
  if ('httpGet' in item && item.httpGet) {
    return {
      tab: 'HTTP',
      protocol: item.httpGet.scheme as LifecycleManageData['protocol'],
      path: item.httpGet.path,
      httpPort: item.httpGet.port,
    };
  }
  return undefined;
}
